import { Module } from '@nestjs/common'
import { storageController } from './controllers'
import { StorageService } from './services'
import { BusboyModule } from 'nestjs-busboy'
import { FileUploadConsumer } from './consumers'

@Module({
	imports: [BusboyModule],
	controllers: [storageController],
	providers: [StorageService, FileUploadConsumer],
})
export class StorageModule {}
